import React from 'react';
import { Box, createStyles, Theme, withStyles } from '@material-ui/core';
import FsCaption from 'ui-elements/typography/FsCaption';
import FsBody from 'ui-elements/typography/FsBody';

export const ContainerBox = withStyles(({ spacing, breakpoints }: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column-reverse',
    marginTop: spacing(2),
    [breakpoints.up(700)]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
  },
}))(Box);

export const HeaderBox = withStyles({
  root: {
    flexGrow: 1,
  },
})((props) => <Box {...props} />);

export const List = withStyles(({ breakpoints }: Theme) => ({
  root: {
    [breakpoints.up(700)]: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  },
}))(Box);

export const Item = withStyles(({ spacing, breakpoints }: Theme) => ({
  root: {
    marginBottom: spacing(2),
    [breakpoints.up(600)]: {
      display: 'flex',
      alignItems: 'baseline',
      margin: spacing(0, 2, 1, 0),
    },
  },
}))(Box);

export const Caption = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      marginRight: spacing(1),
      letterSpacing: 0,
      color: palette.grey.A100,
    },
  })
)((props) => <FsCaption {...props} />);

export const Value = withStyles(({ palette }: Theme) =>
  createStyles({
    root: {
      fontSize: 14,
      fontWeight: 500,
      color: palette.grey.A200,
    },
  })
)((props) => <FsBody {...props} />);
